export default {
  TreasuryCash: 1, //'Rút dự toán tiền mặt',
  TreasuryTransfer: 2, // 'Rút dự toán chuyển khoản',
  TreasuryToAccountCash: 3, // 'Rút dự toán về tài khoản tiền gửi',
  TreasuryDepositsToCash: 4, //'Rút tiền gửi KB về tiền mặt',
  SpendTransfer: 5, // Chi tiền gửi tại Kho bạc,
  AdvancePayment: 6, //'Thanh toán tạm ứng',
  InvestmentWithTransfer: 7, //'Rút vốn đầu tư bằng chuyển khoản',
  InvestmentWithCash: 8, //'Rút vốn đầu tư bằng tiền mặt',
  InvestmentAdvance: 9, //'Thanh toán vốn đầu tư',
  Adjustment: 10, //'Nộp trả kinh phí',
};
